import setIsSearchHistoryDirty from '../actions/setIsSearchHistoryDirty';
import { getStore as getSearchStore } from '../store/Store';
import { mutator } from 'satcheljs';

/**
 * Mutator to set isSearchHistoryDirty to a desired value in the search store
 */
export default mutator(
    setIsSearchHistoryDirty,
    function setIsSearchHistoryDirtyMutator({
        isSearchHistoryDirty,
    }: {
        isSearchHistoryDirty: boolean;
    }) {
        getSearchStore().isSearchHistoryDirty = isSearchHistoryDirty;
    }
);
